import { PainelPropsGrid } from './styles'
import { Popover } from 'antd'

import {
  faArrowAltCircleLeft,
  faArrowAltCircleRight,
  faDownLeftAndUpRightToCenter,
  faDrawPolygon,
  faEdit,
  faFileExport,
  faFloppyDisk,
  faFolder,
  faList,
  faTrash,
  faUpRightAndDownLeftFromCenter,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useState } from 'react'
import { AbasDoGrid } from '../abas'
import { GridMalha, GridPolygon } from '../gerarMalha'
import { baixarGridKML, gerarArquivoShp } from '../../meta'
import * as turf from '@turf/turf'
import { AbaMapa } from './abaMapa'
import { AbaPontos } from './abaPontos'
import { AbaOrdenacao } from './abaOrdenacao'
import ButtonCustom from '../../../../../../../../../../../../../../Components/ButtonCustom'
import { Render } from '../../../../../../../../../../../../../../Components/CustomUi/render'
import Carregando from '../../../../../../../../../../../../../../Components/CustomUi/loading'
import { Switcher } from '../../../../../../../../../../../../../../Components/CustomUi/Switcher'

interface PropsConfig {
  disable: boolean
  setDisable: React.Dispatch<React.SetStateAction<boolean>>
  aoCarregarArquivo: (rawData: string, base64Data: string) => void
  validoFile: boolean
  setValidoFile: React.Dispatch<React.SetStateAction<boolean>>
  rotation: number
  setRotation: React.Dispatch<React.SetStateAction<number>>
  rotacaoInput: string
  setRotacaoInput: React.Dispatch<React.SetStateAction<string>>
  movendo: boolean
  setMovendo: React.Dispatch<React.SetStateAction<boolean>>
  novoPonto: boolean
  setNovoPonto: React.Dispatch<React.SetStateAction<boolean>>
  moverPonto: boolean
  setMoverPonto: React.Dispatch<React.SetStateAction<boolean>>
  removerPonto: boolean
  setRemoverPonto: React.Dispatch<React.SetStateAction<boolean>>
  selecionarPonto: boolean
  setSelecionarPonto: React.Dispatch<React.SetStateAction<boolean>>
  gridLevel: string
  setGridLevel: React.Dispatch<React.SetStateAction<string>>
  position: { x: 0; y: 0 }
  setPosition: React.Dispatch<React.SetStateAction<{ x: number; y: number }>>
  tab_container_atual: string
  setTab_container_atual: React.Dispatch<React.SetStateAction<string>>
  arquivoSelecionado: string
  setArquivoSelecionado: React.Dispatch<React.SetStateAction<string>>
  setGrid: React.Dispatch<React.SetStateAction<GridMalha[]>>
  setGridOriginal: React.Dispatch<React.SetStateAction<GridMalha[]>>
  setGridOriginalRotacao: React.Dispatch<React.SetStateAction<GridMalha[]>>
  setTamanhoGridOriginal: React.Dispatch<React.SetStateAction<number>>
  setMalhaPolygon: React.Dispatch<React.SetStateAction<GridPolygon[]>>
  setMalhaPolygonOriginal: React.Dispatch<React.SetStateAction<GridPolygon[]>>
  setClicou: React.Dispatch<React.SetStateAction<boolean>>
  setQuadrante: React.Dispatch<React.SetStateAction<number>>
  kmlComCruzamento: boolean
  editandoKml: boolean
  setEditandoKml: React.Dispatch<React.SetStateAction<boolean>>
  areaHectares: number
  polygon: turf.Feature
  abaAtual: number
  abasNome: any[]
  pontosSelecionados: any[]
  grid: GridMalha[]
  area: any[]
  areaTamanho: number
  quadrante: number
  nomeTalhao: string
  avancar: Function
  voltar: Function
  resetarGrid: Function
  salvarMalha: () => void
  baixarMalha: (tipo: string) => void
  salvarContorno: () => void
}

const Configuracoes: React.FC<PropsConfig> = ({
  aoCarregarArquivo,
  validoFile,
  rotation,
  setRotation,
  rotacaoInput,
  setRotacaoInput,
  movendo,
  setMovendo,
  novoPonto,
  setNovoPonto,
  moverPonto,
  setMoverPonto,
  removerPonto,
  setRemoverPonto,
  selecionarPonto,
  setSelecionarPonto,
  gridLevel,
  setGridLevel,
  position,
  setPosition,
  tab_container_atual,
  setTab_container_atual,
  arquivoSelecionado,
  setArquivoSelecionado,
  setGrid,
  setGridOriginal,
  setGridOriginalRotacao,
  setTamanhoGridOriginal,
  setQuadrante,
  kmlComCruzamento,
  editandoKml,
  setEditandoKml,
  areaHectares,
  polygon,
  abaAtual,
  abasNome,
  pontosSelecionados,
  grid,
  area,
  areaTamanho,
  quadrante,
  avancar,
  voltar,
  nomeTalhao,
  resetarGrid,
  salvarMalha,
  baixarMalha,
  salvarContorno,
}) => {

  const [show, setShow] = useState<boolean>(false)
  const [shrink, setShrink] = useState<boolean>(false)
  const [loading, setLoading] = useState<string>('')

  return (
    <PainelPropsGrid data-shrink={shrink}>
      <div style={{ width: '100%', justifyContent: 'space-between', display: 'flex' }}>

        <ButtonCustom
          onClick={() => {
            setShrink(!shrink)
          }}
          type={shrink ? 'primary' : 'tertiary'}
          icon={
            <FontAwesomeIcon
              icon={shrink ? faUpRightAndDownLeftFromCenter : faDownLeftAndUpRightToCenter}
            />
          }
          style={{ marginLeft: -15, alignSelf: 'flex-end', right: 0 }}
        />
      </div>
      <Render condition={shrink === false}>
        <AbasDoGrid abaAtual={tab_container_atual} mostrar={shrink} />

        {/* Banner de edição KML */}

        <Render condition={show === false}>
          <Render condition={tab_container_atual === 'Mapa'}>
            <AbaMapa
              aoCarregarArquivo={aoCarregarArquivo}
              validoFile={validoFile}
              rotation={rotation}
              setRotation={setRotation}
              rotacaoInput={rotacaoInput}
              setRotacaoInput={setRotacaoInput}
              gridLevel={gridLevel}
              setGridLevel={setGridLevel}
              position={position}
              setPosition={setPosition}
              movendo={movendo}
              setMovendo={setMovendo}
              loading={loading}
              setLoading={setLoading}
              setGrid={setGrid}
              setGridOriginal={setGridOriginal}
              setGridOriginalRotacao={setGridOriginalRotacao}
              setTamanhoGridOriginal={setTamanhoGridOriginal}
              setQuadrante={setQuadrante}
              areaHectares={areaHectares}
              polygon={polygon}
              grid={grid}
              area={area}
              editandoKml={editandoKml}
              setEditandoKml={setEditandoKml}
              kmlComCruzamento={kmlComCruzamento}
              salvarContorno={salvarContorno}
            />
          </Render>

          <Render condition={tab_container_atual === 'Pontos'}>
            <AbaPontos
              novoPonto={novoPonto}
              setNovoPonto={setNovoPonto}
              moverPonto={moverPonto}
              setMoverPonto={setMoverPonto}
              removerPonto={removerPonto}
              setRemoverPonto={setRemoverPonto}
              area={areaTamanho}
              grid={grid}
              quadrante={quadrante}
            />
          </Render>

          <Render condition={abaAtual === 2}>
            <AbaOrdenacao
              selecionarPonto={selecionarPonto}
              setSelecionarPonto={setSelecionarPonto}
              arquivoSelecionado={arquivoSelecionado}
              setArquivoSelecionado={setArquivoSelecionado}
              pontosSelecionados={pontosSelecionados}
              resetarGrid={resetarGrid}
            />
          </Render>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <ButtonCustom
              onClick={voltar}
              type='secondary'
              danger
              icon={<FontAwesomeIcon icon={faArrowAltCircleLeft} />}
              disabled={tab_container_atual === 'Mapa'}
            >
              Voltar
            </ButtonCustom>
            <Render condition={tab_container_atual === 'Mapa' || tab_container_atual === 'Pontos'}>
              <ButtonCustom
                onClick={avancar}
                type='secondary'
                icon={<FontAwesomeIcon icon={faArrowAltCircleRight} />}
                disabled={grid.length <= 0 || kmlComCruzamento}
              >
                Avançar
              </ButtonCustom>
            </Render>
            <Render condition={abaAtual === 2}>
              <Popover
                trigger='click'
                placement='topRight'
                content={
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 8, minWidth: 90 }}>
                    <ButtonCustom
                      onClick={() => baixarMalha(arquivoSelecionado)}
                      type='secondary'
                      disabled={!arquivoSelecionado}
                      icon={<FontAwesomeIcon icon={faFileExport} />}
                      style={{ width: '100%' }}
                    >
                      Baixar
                    </ButtonCustom>
                    <ButtonCustom
                      onClick={() => salvarMalha()}
                      type='primary'
                      icon={<FontAwesomeIcon icon={faFloppyDisk} />}
                      style={{ width: '100%' }}
                    >
                      Salvar
                    </ButtonCustom>
                  </div>
                }
              >
                <span>
                  <ButtonCustom
                    type='secondary'
                    onClick={() => { }}
                    icon={<FontAwesomeIcon icon={faList} />}
                  >
                    Finalizar
                  </ButtonCustom>
                </span>
              </Popover>
            </Render>
          </div>
        </Render>
      </Render>
      <Render condition={show}>
        <Carregando animation legenda='Carregando...' justifyContent='center' height={400} />
      </Render>
    </PainelPropsGrid>
  )
}

export default React.memo(Configuracoes)